<main class="dashboard">
    <div class="w-100">
        <app-dashboard-admin-assignors></app-dashboard-admin-assignors>
        <app-spacer [bottom]="24"></app-spacer>
    </div>
</main>